import {z} from 'zod'

export type StripePriceId = `price_${string}`
export const StripePriceId = z.string().startsWith('price_') as z.ZodType<StripePriceId>
